import { autoinject, bindable, bindingMode } from "aurelia-framework";

import { IElement } from "../../../interfaces/form-builder/i-element";
import { IAncestorSettings } from "../../../interfaces/form-builder/i-input-options";
import { GroupingTypesEnum } from "./grouping-types-enum";

@autoinject
export class FormGrouping {
    @bindable({ defaultBindingMode: bindingMode.toView })
    public element: IElement;
    @bindable({ defaultBindingMode: bindingMode.toView })
    public parentName: string;
    @bindable({ defaultBindingMode: bindingMode.toView })
    public ancestorSettings: IAncestorSettings;
    public groupingTypesEnum: typeof GroupingTypesEnum = GroupingTypesEnum;
}
